export default {
  getSkillSet: (state) => state.skillSet,
};
